var map = {
	"./alert.svg": 361,
	"./appstore.svg": 362,
	"./arrow-left.svg": 363,
	"./arrow-right.svg": 364,
	"./cancelled.svg": 365,
	"./check.svg": 366,
	"./chevron-down.svg": 367,
	"./chevron-left.svg": 368,
	"./chevron-right.svg": 369,
	"./completed.svg": 370,
	"./cross.svg": 371,
	"./customer.svg": 372,
	"./dashboard.svg": 373,
	"./delete.svg": 374,
	"./dots.svg": 375,
	"./download-cloud.svg": 376,
	"./edit.svg": 377,
	"./facebook.svg": 378,
	"./filter.svg": 379,
	"./hamburger.svg": 380,
	"./info.svg": 381,
	"./instagram.svg": 382,
	"./loading.svg": 383,
	"./lock.svg": 384,
	"./log.svg": 385,
	"./marker.svg": 386,
	"./min.svg": 387,
	"./payment.svg": 388,
	"./pending.svg": 389,
	"./person.svg": 390,
	"./plus.svg": 391,
	"./profile.svg": 392,
	"./search.svg": 393,
	"./settings.svg": 394,
	"./sign-out.svg": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;